import { useTranslation } from 'core/i18n';
import { showErrorNotification, showInfoNotification } from 'core/utils/notification-service';
import React from 'react';
import { triggerOnetimeDeviceImport } from '../onetime-device-import.service';

export const useTriggerOnetimeDeviceImport = () => {
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const { t } = useTranslation();
    const triggerImport = React.useCallback(() => {
        setIsLoading(true);
        return triggerOnetimeDeviceImport()
            .then(() => showInfoNotification(t('settings.context-menu.import-devices.info')))
            .catch(() => showErrorNotification(t('settings.context-menu.import-devices.error')))
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return { isLoading, triggerImport };
};
